// Stores
import { useUiStore } from '@stores/ui'
import { useSecurityStore } from '@stores/security'

// Personal libs
import { Repository } from "./common/repository.class";
import { ICsrf } from "@shared/interface/security.interface";
import { apiGetCsrf, apiPostAllCsrf } from "@data/datasource/remote/security.api";
import { ApiError } from "@shared/error/api.error";
import { FormNameEnum } from '@shared/enum/form-name.enum';

class SecurityRepository extends Repository {
  constructor() {
    super();
  }

  /*****************************************
   *
   * GET FUNCTIONS
   *
   *****************************************/
  // Get all csrf
  async getCsrf(formName: FormNameEnum): Promise<ICsrf | undefined> {
    const securityStore = useSecurityStore()
    const csrfTokenFromStore = await securityStore.getCsrf(formName)
    const fingerprintFromStore = await securityStore.getFingerprint()

    if (csrfTokenFromStore != null) {
      return csrfTokenFromStore
    }
    
    return apiGetCsrf({
      fingerprint: fingerprintFromStore,
      formName: formName
    })
      .then((response: ICsrf) => {
        if (response != null) {
          securityStore.setCsrf(response) 
        }
        
        return response
      })
      .catch((err: ErrorConstructor) => {
        if (err instanceof ApiError) {
          if (err.code === 'CSRF_ERR_01') {
            throw new Error('Utilisateur inconnu');
          } else {
            throw new Error(err.message);
          }
        } else {
          throw new Error('Erreur inconnue');
        }
      });
  }

  /*****************************************
   *
   * POST FUNCTIONS
   *
   *****************************************/
  // Get all csrf
  async getAllCsrf(): Promise<Array<ICsrf> | undefined> {
    const securityStore = useSecurityStore()
    const fingerprint = await securityStore.getFingerprint()
    const formNameListToGet = securityStore.getFormNameListToGet()

    if (formNameListToGet.length === 0) {
      return securityStore.csrfTokens
    }

    return apiPostAllCsrf({
      fingerprint,
      formNameList: formNameListToGet
    })
      .then((response: Array<ICsrf>) => {
        const uiStore = useUiStore()
        securityStore.addCsrfFromList(response)

        return uiStore.csrfTokens
      })
      .catch((err: ErrorConstructor) => {
        if (err instanceof ApiError) {
          if (err.code === 'CSRF_ERR_01') {
            throw new Error('Utilisateur inconnu');
          } else {
            throw new Error(err.message);
          }
        } else {
          throw new Error('Erreur inconnue');
        }
      });
  }
}

export default new SecurityRepository();